import React, { useState, useEffect } from "react";
import { Modal, Button, Table, ProgressBar, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bulkDirectoryDataReportClear } from "../../../Redux/Directory/action";
import { BsUpload, BsCheckCircle } from "react-icons/bs";

const BulkAddDirectoryReportModal = ({ show, progress, dataLength,setShowBulkAddDirectoryReportModal }) => {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [report, setReport] = useState();
  const bulkDirectoryDataReport = useSelector(
    (state) => state.directoryReducer?.bulkAddDirectoryReport,
  );

  useEffect(() => {
    if (bulkDirectoryDataReport) {
      setReport(bulkDirectoryDataReport);
      setLoading(false);
    }
  }, [bulkDirectoryDataReport]);

  useEffect(() => {
    setLoading(true);
  }, []);

  const cleaningBulkAddDirectoryReportModalData = async () => {
    await bulkDirectoryDataReportClear(dispatch);
    window.location.reload();
  };

  return (
    <Modal
      show={show}
      onHide={cleaningBulkAddDirectoryReportModalData}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body>
        {loading ? (
          <div className="d-flex flex-column align-items-center">
            <BsUpload className="h-6 w-6 text-gray-500"/>
            <h2 className="text-xl font-semibold">Uploading</h2>
            <ProgressBar
              now={progress}
              label={`${progress}%`}
              className="w-100"
            />
            <div className="text-sm text-gray-500 mt-2">
              Uploading {Math.floor((progress / 100) * dataLength)} of{" "}
              {dataLength} records
            </div>
          </div>
        ) : (
          <>
            <Row className="d-flex align-items-center justify-content-center">
              <BsCheckCircle size={25} color={"green"} />
              <h4 className="main-h4-tag-large ml-1" style={{ color: "green" }}>
                Completed Report
              </h4>
            </Row>
            <Row className="m-4">
              <Col
                className="p-2 m-1 text-center"
                style={{ border: `1px solid gray` }}
              >
                <h5 style={{ fontWeight: 600, color: "gray" }}>
                  {dataLength ? dataLength :"0"}
                </h5>
                <small>Total Uploads</small>
              </Col>
              <Col
                className=" p-2 m-1 text-center"
                style={{ border: `1px solid green` }}
              >
                <h5 style={{ fontWeight: 600, color: "green" }}>
                  {report?.insertedCount}
                </h5>
                <small>Successful Uploads</small>
              </Col>
              <Col
                className="p-2 m-1 text-center"
                style={{ border: `1px solid orange` }}
              >
                <h5 style={{ fontWeight: 600, color: "orange" }}>
                  {report?.duplicatesCount}
                </h5>
                <small>Duplicates</small>
              </Col>
              <Col
                className="p-2 m-1 text-center"
                style={{ border: `1px solid red` }}
              >
                <h5 style={{ fontWeight: 600, color: "red" }}>
                  {report?.errorCount}
                </h5>
                <small>Errors</small>
              </Col>
            </Row>
            {report?.duplicates?.length ?
            <Row>
              <h4 className="main-h4-tag-large ml-1 text-center w-100">
                Duplicate Contacts
              </h4>
              <Col>
                <div
                  className="mt-2"
                  style={{ overflow: "auto", height: "200px" }}
                >
                  <Table  bordered hover>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Department</th>
                      </tr>
                    </thead>
                    <tbody>
                      {report?.duplicates?.map((contact, index) => (
                        <tr key={index}>
                          <td className="w-25 text-center">{contact?.name}</td>
                          <td className="w-25 text-center">{contact?.email}</td>
                          <td className="w-25 text-center">{contact?.phone}</td>
                          <td className="w-25 text-center">{contact?.department}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>: (
            ""
            )}
            {report?.errors?.length ? (
              <Row>
                <h4 className="main-h4-tag-large ml-1 text-center w-100">
                  Error Contacts
                </h4>
                <Col>
                  <div
                    className="mt-2"
                    style={{ overflow: "auto", height: "200px" }}
                  >
                    <Table bordered hover>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Department</th>
                          <th>Error</th>
                        </tr>
                      </thead>
                      <tbody>
                        {report?.errors?.map((contact, index) => (
                          <tr key={index}>
                            <td className="w-25 text-center">{contact?.name}</td>
                            <td className="w-25 text-center">{contact?.email}</td>
                            <td className="w-25 text-center">{contact?.phone}</td>
                            <td className="w-25 text-center">{contact?.department}</td>
                            <td className="w-25 text-center">{contact?.error}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </>
        )}
      </Modal.Body>
      {!loading && (
        <Modal.Footer>
          <Button
            className="custom-button"
            onClick={cleaningBulkAddDirectoryReportModalData}
          >
            Close
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default BulkAddDirectoryReportModal;
